module.exports = __webpack_public_path__ + "img/gold_logo_bg.9ac774ae.png";